import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const SalesProPage = lazy(() => import('../pages/products/salespro/page'));
const WordProPage = lazy(() => import('../pages/products/wordpro/page'));
const BraveIQPage = lazy(() => import('../pages/products/braveiq/page'));
const SchoolPetalPage = lazy(() => import('../pages/products/schoolpetal/page'));
const TimeTrackProPage = lazy(() => import('../pages/products/timetrackpro/page'));
const CartmorPage = lazy(() => import('../pages/products/cartmor/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const SolutionsPage = lazy(() => import('../pages/solutions/page'));
const ImpactPage = lazy(() => import('../pages/impact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const BMSERPPage = lazy(() => import('../pages/products/bmserp/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/salespro',
    element: <SalesProPage />,
  },
  {
    path: '/products/wordpro',
    element: <WordProPage />,
  },
  {
    path: '/products/braveiq',
    element: <BraveIQPage />,
  },
  {
    path: '/products/schoolpetal',
    element: <SchoolPetalPage />,
  },
  {
    path: '/products/timetrackpro',
    element: <TimeTrackProPage />,
  },
  {
    path: '/products/cartmor',
    element: <CartmorPage />,
  },
  {
    path: '/products/bmserp',
    element: <BMSERPPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/solutions',
    element: <SolutionsPage />,
  },
  {
    path: '/impact',
    element: <ImpactPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:id',
    element: <BlogDetailPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
